import { configureStore } from '@reduxjs/toolkit';
import { authReducer } from './modules/auth';
import { formReducer } from './modules/forms';
import { apiSlice, notificationReducer } from './services';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    form: formReducer,
    notification: notificationReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
